<template>
  <div class="navbar">
    <Logo></Logo>
    <div class="menu-view">
      <div class="menu-main">
        <small v-for="(item, index) in routerList" :key="index">
          <router-link :to="item.path">
            {{ item.meta.title }}
          </router-link>
        </small>
      </div>
    </div>
    <div class="right-menu">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <i class="el-icon-user-solid"></i>
          <small>{{ name || "请登录" }}</small>
          <i class="el-icon-arrow-down"></i>
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item v-if="name">
            <router-link to="/user/center/view/info"> 用户中心 </router-link>
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout" v-if="name">
            退出登陆
          </el-dropdown-item>
          <el-dropdown-item @click.native="login" v-if="!name">
            去登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { removeToken } from "@/utils/auth.js";
import { resetRouter } from "@/router";
import Logo from "./Sidebar/Logo.vue";
export default {
  data() {
    return {};
  },
  components: {
    Logo
  },

  computed: {
    ...mapGetters(["sidebar", "avatar", "name"]),
    routerList() {
      console.log(this.$router);
      const group = "policy"; //this.$route.meta.group;
      const routers = this.$router.getRoutes();
      return routers.filter(item => {
        if (item?.meta?.group) {
          return item.meta.group == group;
        }
      });
    }
  },
  methods: {
    login() {
      this.$router.push(`/login`);
    },
    navigate(href) {
      if (href == "/AAA") {
        return false;
      }
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      removeToken();
      this.$store.commit("user/SET_NAME", "");
      resetRouter();
      this.$router.push(`/login`);
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.navbar {
  height: 100%;
  overflow: hidden;
  position: relative;
  width: @contentWidth;
  margin: 0 auto;
  display: flex;
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    height: 50px;
    padding-top: 15px;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      height: 100%;
      display: flex;
      align-items: center;
      .avatar-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        color: #2d76fc;
        .el-icon-user-solid {
          color: #2d76fc;
          font-size: 20px;
        }

        & small {
          margin-left: 4px;
          font-size: 14px;
          color: #2d76fc;
          cursor: pointer;
        }
        & i {
          cursor: pointer;
          color: #2d76fc;
          margin-left: 6px;
        }
      }
    }
  }
}
.menu-view {
  flex: 1;
  width: 0;
}
.menu-main {
  font-size: 15px;
  color: rgba(41, 59, 104, 1);
  display: flex;
  justify-content: flex-end;
  padding-right: 25px;
  & small {
    font-size: 15px;
    line-height: 65px;
    display: flex;
    &:not(:first-child) {
      margin-left: 38px;
    }
  }
  & a {
    display: block;
    line-height: 65px;
    font-weight: bold;
    position: relative;
    white-space: nowrap;

    &.router-link-active {
      color: rgba(22, 96, 212, 1);
      &::before {
        content: "";
        position: absolute;
        height: 3px;
        width: 100%;
        left: 0;
        bottom: 5px;
        border-radius: 1px;
        background: rgba(22, 96, 212, 1);
      }
    }
  }
}
</style>
